import '@mui/x-data-grid-premium/themeAugmentation'
import '@mui/x-data-grid/themeAugmentation'

const defaultTheme = {
    cssVariables: {
        colorSchemeSelector: 'class',
    },
    typography: {
        fontFamily: '"Roboto Variable", "Helvetica", "Arial", "sans-serif"',
    },
    components: {
        MuiListItemIcon: {
            styleOverrides: {
                root: {
                    minWidth: 56,
                },
            },
        },
        MuiDataGrid: {
            styleOverrides: {
                root: {
                    '& .MuiDataGrid-toolbar .MuiSvgIcon-root': {
                        fontSize: '1.5rem',
                    },
                    '& .MuiDataGrid-footerContainer .MuiSvgIcon-root': {
                        fontSize: '1.5rem',
                    },
                    '& .MuiTablePagination-selectLabel, & .MuiTablePagination-displayedRows, & .MuiTablePagination-select':
                        {
                            fontSize: '1rem',
                        },
                    '& .MuiTablePagination-root': {
                        overflow: 'visible',
                    },
                },
            },
        },
    },
    shape: {
        borderRadius: 2,
    },
    colorSchemes: {
        light: {
            palette: {
                primary: {
                    main: '#3aa7bd',
                    contrastText: '#FFFFFF',
                },
                secondary: {
                    main: '#453abd',
                },
                warning: {
                    main: '#fff176',
                },
                error: {
                    main: '#f44336',
                },
                success: {
                    main: '#a5d6a7',
                    dark: '#2e7d32',
                },
            },
        },
        dark: {
            palette: {
                primary: {
                    main: '#4dd0bc',
                    contrastText: '#08221F',
                },
                secondary: {
                    main: '#8a82e0',
                },
                warning: {
                    main: '#fff176',
                },
                error: {
                    main: '#f44336',
                },
                success: {
                    main: '#81c784',
                    dark: '#2e7d32',
                },
                background: {
                    default: '#121212',
                    paper: '#1e1e1e',
                },
            },
        },
    },
}

export default defaultTheme
